var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTickCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0003 9.1665C29.7462 9.1665 9.16699 29.7457 9.16699 54.9998C9.16699 80.254 29.7462 100.833 55.0003 100.833C80.2545 100.833 100.834 80.254 100.834 54.9998C100.834 29.7457 80.2545 9.1665 55.0003 9.1665ZM76.9087 44.4582L50.9212 70.4457C50.2795 71.0873 49.4087 71.454 48.492 71.454C47.5753 71.454 46.7045 71.0873 46.0628 70.4457L33.092 57.4748C31.7628 56.1457 31.7628 53.9457 33.092 52.6165C34.4212 51.2873 36.6212 51.2873 37.9503 52.6165L48.492 63.1582L72.0503 39.5998C73.3795 38.2707 75.5795 38.2707 76.9087 39.5998C78.2378 40.929 78.2378 43.0832 76.9087 44.4582Z",
    fill: "#28C269"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.ad7338d2dd9807b331ebdea8cc582bb0.svg";
export { ForwardRef as ReactComponent };